/* src/auth/actions.js */

import {
  validateTokenTypes,
  loginTypes,
  login2faTypes,
  verify2faTypes,
  fetchUserTypes,
  forgotPasswordTypes,
  SELECT_UNIVERSITY,
  SELECT_ORGANIZATION,
  CLEAR_AUTH,
} from './action_types';

import { makeMutation, makeQuery, makeActionCreator } from '../../config/client';
import {
  VALIDATE_TOKEN_MUTATION,
  FETCH_USER_QUERY,
  LOGIN_MUTATION,
  LOGIN_2FA_MUTATION,
  VERIFY_2FA_MUTATION,
  FORGOT_PASSWORD_MUTATION,
} from './api';

export const validateToken = variables => makeMutation({ variables })(
  validateTokenTypes,
  VALIDATE_TOKEN_MUTATION
);

/**
 * @param {Object} credentials - admin credentials.
 * @param {string} credentials.email - admin email.
 * @param {string} credentials.password - admin password.
 * @returns {function} - function to log in.
 */
export const login = credentials => makeMutation({ variables: credentials })(
  loginTypes,
  LOGIN_MUTATION
);

export const login2fa = variables => makeMutation({ variables })(
  login2faTypes,
  LOGIN_2FA_MUTATION
);

export const verify2fa = variables => makeMutation({ variables })(
  verify2faTypes,
  VERIFY_2FA_MUTATION
);

export const clearAuth = () => ({ type: CLEAR_AUTH });

/**
 * @returns {function} - Fetches admin object.
 */
export const fetchUser = () => makeQuery()(fetchUserTypes, FETCH_USER_QUERY);

export const forgotPassword = variables => makeMutation({ variables })(
  forgotPasswordTypes,
  FORGOT_PASSWORD_MUTATION
);

/**
 * @param {string} payload - university id.
 * @returns {function} - action creator to filter universities.
 */
export const selectUniversity = makeActionCreator(SELECT_UNIVERSITY);

/**
 * @param {string} payload - organization id.
 * @returns {function} - action creator to filter organizations.
 */
export const selectOrganization = makeActionCreator(SELECT_ORGANIZATION);

// deprecated
export const fetchUserFail = () => {};
export const fetchUserAfterLogin = () => {};
export const fetchUserSuccess = () => {};



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js